export default __webpack_public_path__ + "static/media/title flyer.187e9d81.pdf";